import React from "react";
import { cn } from "~/utils";

export default React.forwardRef(function (
  { children, className, subtitle, title, ...props },
  ref,
) {
  return (
    <div
      ref={ref}
      className={cn(
        "container mx-auto flex min-h-[calc(100vh-57px)] max-w-6xl flex-col gap-16 p-6 md:p-8 lg:p-12",
        className,
      )}
      {...props}
    >
      {(title || subtitle) && (
        <div className="flex flex-col gap-1">
          {title && <h1 className="m-0 text-3xl font-bold">{title}</h1>}
          {subtitle && (
            <p className="m-0 max-w-2xl text-gray-700">{subtitle}</p>
          )}
        </div>
      )}
      {children}
    </div>
  );
});
